import styled, { css } from 'styled-components'

const positionStyle = ({ position }) => {
  if (position === 'left') {
    return css`
      background-image: linear-gradient(to right, rgba(255, 255, 255, 0.1), rgb(255, 255, 255, 1));
      top: 0;
      right: -2px;
    `
  }

  return css`
    background-image: linear-gradient(to right, rgba(255, 255, 255, 1), rgb(255, 255, 255, 0.1));
    top: 0;
    left: -2px;

  `
}

const ReportsTableStyle = ({ activeTab }) => {
  if (activeTab === 'siteDetails') {
    return css`
      th, td {
        white-space: nowrap;
        padding: 0 24px;
      }

      th:first-child,
      td:first-child {
        padding-left: 16px;
      }

      th:last-child,
      td:last-child {
        padding: 0 16px 0 24px;
      }
    `
  }

  if (activeTab === 'speciesAtSite') {
    return css`
      th, td {
        white-space: nowrap;
        padding: 0 24px;
      }

      th:first-child,
      td:first-child {
        padding-left: 16px;
      }

      th:last-child,
      td:last-child {
        padding: 0 16px 0 24px;
      }
    `
  }

  if (activeTab === 'ecosystemsAtSite') {
    return css`
      th, td {
        white-space: nowrap;
        padding: 0 24px;
      }

      th:first-child,
      td:first-child {
        padding-left: 16px;
      }

      th:last-child,
      td:last-child {
        padding: 0 16px 0 24px;
      }
    `
  }

  if (activeTab === 'usersAndAssessment') {
    return css`
      th, td {
        white-space: nowrap;
        padding: 0 24px;
      }

      th:first-child,
      td:first-child {
        padding-left: 16px;
      }

      th:last-child,
      td:last-child {
        padding: 0 16px 0 24px;
      }
    `
  }
}

export const NewReportWrapper = styled.div`
  height: calc(100vh - 72px);
  display: grid;
  place-items: center;
`
export const NewReportSubWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
export const CreateReportsButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`
export const NewReportTitle = styled.div`
  font-size: 20px;
  line-height: 32px;
  font-weight: 600;
`
export const NewReportSubTitle = styled.div`
  width: 392px;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: rgba(32, 32, 32, 0.7);
`
export const ReportsWrapper = styled.div`
  font-weight: 500;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 32px 56px;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
  align-items: center;
`

export const RightButtons = styled.div`
  display: flex;
  gap: 8px;

  button svg {
    margin-right: 8px;
  }
`
export const OverviewWrapper = styled.div`
  padding: 48px 56px 0 56px;
  width: 100%;
`

export const OverviewTitle = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #202020;
  margin-bottom: 24px;
`

export const OverviewBoxes = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid rgba(32, 32, 32, 0.1);
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  border-radius: 4px;
  padding: 0 37px;
`

export const StyleIcon = styled.div`
  padding: 40px 16px 40px 0;
`

export const Circle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: ${(props) => {
    return props.background
  }};
  border-radius: 24px;
`

export const InnerCircle = styled.div`
  background: ${(props) => {
    return props.background
  }};
  width: 12px;
  height: 12px;
  border-radius: 24px;
`

export const StyleArrow = styled.div`
  padding: 0 23px;
  @media (min-width: 1441px) {
    padding: 0 39px;
  }
`

export const StyledRightCorner = styled.div`
  position: absolute;
  right: -8px;
  top: -6px;
  background-color: white;
  padding-top: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  padding-left: 5px;
  font-size: 12px;
`
export const BoxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`

export const BoxHalfSide = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`
export const Divider = styled.div`
  height: ${(props) => {
    return props.height ? props.height : '40px'
  }};
  width: 1px;
  background-color: rgba(32, 32, 32, 0.1);
  margin: ${(props) => {
    return props.margin ? props.margin : ' 0 37px'
  }};
`

export const ValueContainer = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  color: #202020;
  line-height: 40px;
`

export const ReportsTabWrapper = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
`

export const ReportsTabItem = styled.div`
  user-select: none;
  display: flex;
  align-items: center;
  padding: 12px 16px;

  color: ${(p) => {
    return p.isActive ? '#0aa1f4' : p.disabled ? 'rgba(32, 32, 32, 0.5)' : 'rgba(32, 32, 32, 0.7)'
  }};

  cursor: pointer;

  pointer-events: ${(props) => {
    return props.disabled ? 'none' : ''
  }};

  border: ${(p) => {
    return p.isActive ? 'none' : '1px solid rgba(32, 32, 32, 0.2)'
  }};

  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);

  background: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 0.1)' : p.disabled ? 'rgba(32, 32, 32, 0.05)' : 'none'
  }};
  border-radius: 24px;
  margin: 0 4px;

  :hover {
    color: ${(props) => {
      return props.isActive ? '' : '#202020'
    }};
  }
`

export const TabsArrowIconWrapper = styled.div`
  height: 40px;
  width: 40px;
  display: grid;
  place-items: center;
  cursor: pointer;
  border-radius: 50%;

  @media (min-width: 1600px) {
    display: none;
  }

  :hover {
    background-color: ${(p) => {
      return p.disabled ? 'none' : 'rgba(32, 32, 32, 0.04)'
    }};

    path {
      fill-opacity: ${(p) => {
        return p.disabled ? '0.5' : '1'
      }};
      fill: rgb(32, 32, 32);
    }
  }
`
export const FilterTabSliderContainer = styled.div`
  width: 650px;
  overflow-x: hidden;
  padding: 0 16px;
  position: relative;

  @media (min-width: 1600px) {
    width: 960px;
  }

  @media (max-width: 1440px) {
    width: 740px;
  }

  @media (max-width: 1380px) {
    width: 650px;
  }
`

export const FilterTabsContainer = styled.div`
  display: flex;
  width: 960px;
  transition: 1s;
  transform: ${(p) => {
    return p.position === 'left' ? 'translateX(-10px)' : 'translateX(-240px)'
  }};

  @media (max-width: 1380px) {
    transform: ${(p) => {
      return p.position === 'left' ? 'translateX(-10px)' : 'translateX(-320px)'
  }}
  }
`

export const FiltersTabsOpacityRight = styled.div`
  position: absolute;
  height: 42px;
  width: 150px;
  ${positionStyle};

  @media (min-width: 1600px) {
    display: none;
  }
`
export const ReportTableWrapper = styled.div`
  padding: 52px 56px 0 56px;
  width: 100%;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`

export const ReportTableTitle = styled.div`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #202020;
`

export const Dash = styled.span`
  padding: 0 8px;
`

export const ReportsTableWrapper = styled.div`
  width: ${(p) => {
    return p.expanded ? '100vw' : 'calc(100vw - 216px)'
  }};
  margin: ${(p) => {
    return p.expanded ? 'unset' : '0 56px 32px 56px;'
  }};

  ${ReportsTableStyle}
`

export const ExpandedTableHeader = styled.div`
  width: 100%;
  padding: 0 64px;
  display: flex;
  align-items: center;
  margin-bottom: 64px;
`

export const ExpandedTableLeftSide = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-start;
`

export const ExpandedTableRightSide = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;

`

export const ExpandedTableHeaderTitle = styled.div`
  font-size: 20px;
  line-height: 32px;
  font-weight: 400;
  display: flex;
  justify-content: center;
  flex-grow: 1;
`

export const ExpandedTableWrapper = styled.div`
  height: auto;
  max-height: calc(100vh - 186px);
  overflow: auto;
  margin: 0 64px;
`

export const ReportsIucnStatusWrapper = styled.div`
  width: 32px;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 4px 8px 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: ${(p) => {
    return p.color === '#FFFFFF' ? '1px solid #202020' : p.color === 'rgb(255, 255, 255)' ? '1px solid rgba(32, 32, 32, 0.2)' : 'none'
  }};
  color: ${(p) => {
    return p.color === '#202020' ? '#FFF' : '#202020'
  }};
  background-color: ${(p) => {
    return p.color
  }};
`

export const ReportsFactsheetWrapper = styled.div`
  display: flex;
`

export const ReportsFactsheetIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: grid;
  place-items: center;
  border-radius: 50%;

  :hover {
    background-color: rgba(32, 32, 32, 0.04);
    path {
      fill: rgb(32, 32, 32);
      fill-opacity: 1;
    }
  }
`

export const ReportsPaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: calc(100vw - 216px);
  margin: 0 56px;
`

export const StickyTableWrapper = styled.div`
  margin: 0 64px;
`

export const ReportLoadingScreen = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  display: grid;
  place-items: center;
  background: rgba(32, 32, 32, 0.5);;
`

export const ReportLoadingScreenBanner = styled.div`
  padding: 64px;
  background-color: #FFFFFF;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const ReportLoadingScreenBannerRunReportIconWrapper = styled.div`
  height: 48px;
  width: 48px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background-color: #0AA1F4;
`

export const ReportLoadingScreenBannerTitle = styled.div`
  margin: 24px 0 8px 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`

export const ReportLoadingScreenBannerMinorIconWrapper = styled.div`
  margin-bottom: 16px;
`

export const StatusDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin-right: 8px;
  display: inline-block;
`
